import {
	Card,
	makeStyles,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography
} from '@material-ui/core';
import TableContainer from "@material-ui/core/TableContainer";
import React from 'react';
import { Line } from 'react-chartjs-2';
import { LTTB } from 'downsample';
import * as dayjs from 'dayjs';
import { useValues } from 'kea';

import { rtemperaturelogic } from 'src/store/report';

import TemperatureDataDialog from './AddDataDialogs/TemperatureDialog';
import CSVDialog from '../../../utils/CSVDialog';
import PDFDialog from '../../../utils/PDFDialog';

const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	}
});

const columns = [
	{
		field: 'timestamp',
		headerName: 'Timestamp',
		align: 'left',
		width: 100,
	},
	{
		field: 'address',
		headerName: 'Address',
		align: 'left',
		width: 180,
	},
	{
		field: 'temperature',
		headerName: 'Temperature (°C)',
		align: 'left',
		width: 180,
	},
];


const initialRowsPerPage = 10;
const Milage = () => {
	const classes = useStyles();
	// const [page, setPage] = React.useState(0);
	const { report } = useValues(rtemperaturelogic);
	const rows = report.events || [];
	const [data, setData] = React.useState({});
	const [exportData, setExportData] = React.useState([]);
	React.useEffect(() => {
		let points = rows.map(p => [Date.parse(p.position_timestamp), p.io.temperature]);
		points = LTTB(points, 100);
		const tmp_data = {
			labels: points.map((p) => p[0]),
			datasets: [
				{
					type: 'line',
					label: 'Temperature (°C)',
					backgroundColor: '#3f51b5',
					borderColor: '#3f51b5',
					borderWidth: 2,
					fill: false,
					data: points.map((p) => p[1]),
				},
			],
		};
		setData(tmp_data);
		let newExportData = rows.map(row => {
			return {
				timestamp: `${dayjs(row.position_timestamp).format('HH:mm:ss  DD MMM YYYY')}`,
				address: row.address,
				temperature: row.io.temperature
			}
		})
		setExportData(newExportData);
	}, [report])

	return (
		<>
			<div style={{ display: 'flex', flexGrow: 1 }}>
				<TemperatureDataDialog />
				<div
					style={{ paddingLeft: '15px' }}>
				</div>
				{
					rows.length > 0 ?
						<CSVDialog columns={columns} additionalData={[
							report.vehicle ?
								`${report.vehicle.type} - ${report.vehicle.registration_number} ${report.vehicle.company} ${report.vehicle.model} ${report.vehicle.year} ${report.vehicle.color}`
								:
								'No Data']} rows={exportData} filename={`Temperature Report - ${dayjs().format('HH:mm:ss  DD MMM YYYY')}.csv`} />
						:
						null
				}
				<div
					style={{ paddingLeft: '15px' }}>
				</div>
				{
					rows.length > 0 ?
						<PDFDialog
							columns={columns} rows={exportData} title='Temperature Report'
							filename={`Temperature Report - ${dayjs().format('HH:mm:ss  DD MMM YYYY')}.pdf`} />
						:
						null
				}
			</div>
			<div
				style={{ paddingTop: '15px' }}>
			</div>
			<Card
				className={classes.root}
			>
				<div style={{ height: '100%', width: '100%', background: 'white' }}>
					<TableContainer className={classes.container}>
						<Table stickyHeader aria-label="sticky table" size={'small'}>
							<TableHead>
								<TableRow>
									<TableCell colSpan={6} align={'left'}>
										<Typography variant="h4" >
											Temperature Report
										</Typography>
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell
										colSpan={7}
									>
										{
											report.vehicle
												?
												<Typography>
													{`${report.vehicle.type} - ${report.vehicle.registration_number} ${report.vehicle.company} ${report.vehicle.model} ${report.vehicle.year} ${report.vehicle.color}`}
												</Typography>
												:
												<Typography>
													No Data
												</Typography>
										}
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								<TableRow>
									<TableCell style={{ height: 33 * initialRowsPerPage }} colSpan={5} align={'center'}>
										<Line
											data={data}
											width={100}
											height={500}

											options={{
												downsample: {
													enabled: true,
													threshold: 300 // max number of points to display per dataset
												},
												plugins: [{
													decimation: {
														enabled: true,
														algorithm: 'lttb'
													},
													// downsample: {
													// 	enabled: true,
													// 	threshold: 300 // max number of points to display per dataset
													// },
													crosshair: {
														line: {
															color: '#F66',	// crosshair line color
															width: 1		// crosshair line width
														},
													}
												}],
												parsing: false,
												showLine: false,
												spanGaps: true,
												scales: {
													yAxes: [{
														min: 0,
														max: 50,
														scaleLabel: {
															display: true,
															labelString: 'Temperature (°C)'
														}
													}],
													xAxes: [{
														type: 'time',
														display: true,
														scaleLabel: {
															display: true,
															labelString: "Time",
														},
														time: {
															stepSize: 5,
															displayFormats: {
																'millisecond': 'ddd HHa',
																'second': 'ddd HHa',
																'minute': 'ddd HHa',
																'hour': 'ddd HHa',
																'day': 'ddd HHa',
																'week': 'ddd HHa',
																'month': 'ddd HHa',
																'quarter': 'ddd HHa',
																'year': 'ddd HHa',
															}
														}
													}]
												},
												maintainAspectRatio: false,
												legend: {
													labels: {
														usePointStyle: true
													}
												},
												tooltips: {
													custom: (chart) => {
														try {
															if (!chart.body[0].lines[0].includes('Celsius')) {
																chart.opacity = 1;
																return chart;
															}
														} catch (error) {

														}
													}
												}
											}}
										/>
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
					{/* </Paper> */}
				</div>
			</Card>
		</>
	);
};


export default Milage;